module.exports = __webpack_public_path__ + "img/location.6ad950ef.svg";